module.exports = __webpack_public_path__ + "images/2974bd65003d243cf57c502a95b488bb.jpg";